<template>
  <div class="row">
    <div class="col-sm-12 mb-4">
      <h2>Lista de Conceptos de Pago</h2>
    </div>

    <div class="col-sm-12 mb-3 d-none d-sm-block">
      <div class="row">
        <div class="col-sm-1"><h4>#</h4></div>
        <div class="col-sm-2"><h4>Tipo</h4></div>
        <div class="col-sm-2"><h4>Importe</h4></div>
        <div class="col-sm-2"><h4>Banco</h4></div>
        <div class="col-sm-2"><h4>Código Postal</h4></div>
        <div class="col-sm-2"><h4>Fecha de Acreditación</h4></div>
      </div>
    </div>

    <!-- SM MD LG XL -->
    <div v-for="(item, index) in items" :key="`concept-payment-${index}`" class="col-sm-12 d-none d-sm-block">
      <div class="row">
        <div class="col-sm-1">
          <small>{{ item.number }}</small>
        </div>
        <div class="col-sm-2">
          <small>{{ getItemDescription(item) }}</small>
        </div>
        <div class="col-sm-2">
          <small>{{ item.amountInPesos | toCurrencyARS }}</small>
        </div>
        <div class="col-sm-2">
          <small>{{ item.bank }}</small>
        </div>
        <div class="col-sm-2">
          <small>{{ item.postalCode }}</small>
        </div>
        <div class="col-sm-2">
          <small>{{ item.accreditationDate | date }}</small>
        </div>
        <div class="col-sm-1 my-2">
          <base-button
            v-if="edit"
            class="rounded-pill btn btn-danger btn-sm"
            size="sm"
            type="danger"
            title="Eliminar"
            @click="deleteItem(item, index)"
          >
            <i class="fas fa-trash"></i>
          </base-button>
        </div>
      </div>
      <hr class="my-3" />
    </div>
  </div>
</template>

<script>
import ConceptPaymentTypesMixin from '@/mixins/ConceptPaymentTypesMixin';

export default {
  name: 'ItemInfo',

  mixins: [ConceptPaymentTypesMixin],

  props: {
    items: {
      type: Array,
      default: null,
    },

    edit: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    getItemDescription(item) {
      const conceptPaymentType = this.conceptPaymentTypes.find(
        (conceptPaymentType) => conceptPaymentType.id === item.conceptPaymentType.id
      );

      return conceptPaymentType ? conceptPaymentType.description : '';
    },

    deleteItem(item, index) {
      this.$emit('deleteItem', item, index);
    },
  },
};
</script>
